/**
 * @desc 获取报警规则详情
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.AlertRuleDetailIotRequest,
): Promise<defs.StandardReturn<defs.IotAlertRuleDetailResult>> {
  return defHttp.post({
    url: '/web/alert/rule/getAlertRuleDetail',
    data,
  });
}

export function mock(
  data: defs.AlertRuleDetailIotRequest,
): Promise<defs.StandardReturn<defs.IotAlertRuleDetailResult>> {
  return defHttp.post({
    url: '/mock/web/alert/rule/getAlertRuleDetail',
    data,
  });
}
